import { DataBean } from "../DataBean";

export class BackUpVersion extends DataBean {



    public async getDocumentVersionBackupCatalog(idEmployee:any,year:any,month:any,idDocument:any,type:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getDocumentVersionBackupCatalog_Number_Number_Number_Number_Number_Number_Number", [idEmployee,year,month,idDocument,type,page,recordsPerPage]);
    }
}